module.exports = __webpack_public_path__ + "static/media/circle.87bcf0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Features/circle.jpg
// module id = 317
// module chunks = 0